import type { SliderDataZoomComponentOption } from 'echarts/types/dist/option';

import type { Data, ReportDashboardComponentViewData } from '@core/reports-types';

export const dataZoom = (
  component: ReportDashboardComponentViewData,
  data: Data,
): SliderDataZoomComponentOption[] => {
  const resultsLength = data.length - 1;
  const limit = 8;

  return [
    {
      show: resultsLength > limit,
      right: 30,
      type: 'slider',
      orient: 'vertical',
      filterMode: 'none',
      brushSelect: false,
      showDetail: false,
      showDataShadow: false,
      zoomLock: true,
      width: 15,
      throttle: 100,
      handleStyle: {
        opacity: 0,
      },
      ...dataZoomRange(limit),
    },
  ];
};

export const dataZoomRange = (limit: number) => ({
  startValue: 0,
  endValue: limit,
});
